/** An order's currency, read through a `transactioncurrency` link under this alias. */
export const CURRENCY_ALIAS = 'currency';
/** Its ISO code in a row, which picks the symbol the order's total is shown with. */
export const CURRENCY_CODE = `${CURRENCY_ALIAS}.isocurrencycode`;
export const CURRENCY_PRECISION = `${CURRENCY_ALIAS}.currencyprecision`;

/** Brings `CURRENCY_CODE` into an order query's rows. */
export const CURRENCY_LINK =
  `<link-entity name="transactioncurrency" from="transactioncurrencyid" to="transactioncurrencyid" link-type="outer" alias="${CURRENCY_ALIAS}">` +
  '<attribute name="isocurrencycode" /></link-entity>';
